import {
  getCurrentDashTrialInfo,
  startSyncDashTrialInfo,
} from "@mirage/service-dash-trial";
import { useEffect, useState } from "react";

export function useDashTrialInfo() {
  const [daysRemainingInDashTrial, setDaysRemaining] = useState(0);
  const [dashTrialActivated, setTrialActivated] = useState(false);
  const [adminName, setAdminName] = useState<string | undefined>(undefined);
  const [dashTrialName, setTrialName] = useState<string | undefined>(undefined);
  const [adminEmail, setAdminEmail] = useState<string | undefined>(undefined);
  const [displayDashTrialIndicator, setDisplayDashTrialIndicator] =
    useState(false);

  useEffect(() => {
    startSyncDashTrialInfo();
  }, []);

  useEffect(() => {
    const subscription = getCurrentDashTrialInfo().subscribe(
      (dashTrialInfo) => {
        if (dashTrialInfo) {
          setDaysRemaining(dashTrialInfo.days_remaining);
          setTrialActivated(dashTrialInfo.trial_activated);
          setAdminName(dashTrialInfo.admin_name);
          setAdminEmail(dashTrialInfo.admin_email);
          setTrialName(dashTrialInfo.trial_name);
          setDisplayDashTrialIndicator(
            dashTrialInfo.display_dash_trial_indicator,
          );
        }
      },
    );
    return () => subscription.unsubscribe();
  }, []);

  return {
    daysRemainingInDashTrial,
    dashTrialActivated,
    adminName,
    adminEmail,
    dashTrialName,
    displayDashTrialIndicator,
  };
}
